import React, { useEffect, useState } from "react";
import "./Modal.css";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { getProvidersNames } from "../../../config/LiveApi";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";

const Modal = ({ onClose, onSubmit, formData, handleInputChange }) => {
  const [fallbackProviderOptions, setFallbackProviderOptions] = useState([]);
  const token = useSelector((store) => store.userReducer.token);

  const options = [
    { name: "payin", label: "payin" },
    { name: "payout", label: "payout" },
    { name: "both", label: "both" },
  ];

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  useEffect(() => {
    const fetchProviders = async () => {
      try {
        const providerRes = await getProvidersNames(token);
        // console.log("Providers:", providerRes);

        setFallbackProviderOptions(providerRes);
      } catch (err) {
        console.error("Error fetching fetchProviders:", err.message);
        toast.error("Unable to fetch fetchProviders.");
      }
    };
    fetchProviders();
  }, []);

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal">
        <h3>Update Provider</h3>

        <form onSubmit={onSubmit}>
          <p className="label-data">Provider Name</p>
          <input
            type="text"
            name="providerName"
            value={formData?.providerName}
            disabled
          />

          <p className="label-data">Type</p>
          <select
            style={{ width: "70%", height: "35px", borderRadius: "8px" }}
            name="type"
            value={formData.type}
            onChange={handleInputChange}
          >
            {options.map((option) => (
              <option key={option.name} value={option.name}>
                {option.label}
              </option>
            ))}
          </select>
          {formData.type === "payin" || formData.type === "both" ? (
            <>
              <p className="label-data">Provider Payin Comm</p>
              <input
                type="text"
                name="providerPayinComm"
                value={formData?.providerPayinComm}
                onChange={handleInputChange}
              />
            </>
          ) : null}
          {formData.type === "payout" || formData.type === "both" ? (
            <>
              <p className="label-data">Provider Payout Comm</p>
              <input
                type="text"
                name="providerPayoutComm"
                value={formData?.providerPayoutComm}
                onChange={handleInputChange}
              />
            </>
          ) : null}

          {formData.type === "payin" || formData.type === "both" ? (
            <>
              <p className="label-data">Minimum Payin per Transaction</p>
              <input
                type="text"
                name="payinMinPerTxn"
                value={formData?.payinMinPerTxn}
                onChange={handleInputChange}
              />
            </>
          ) : null}

          {formData.type === "payin" || formData.type === "both" ? (
            <>
              <p className="label-data">Maximum Payin per Transaction</p>
              <input
                type="text"
                name="payinMaxPerTxn"
                value={formData?.payinMaxPerTxn}
                onChange={handleInputChange}
              />
            </>
          ) : null}

          {formData.type === "payout" || formData.type === "both" ? (
            <>
              <p className="label-data">Minimum Payout per Transaction</p>
              <input
                type="text"
                name="payoutMinPerTxn"
                value={formData?.payoutMinPerTxn}
                onChange={handleInputChange}
              />
            </>
          ) : null}

          {formData.type === "payout" || formData.type === "both" ? (
            <>
              <p className="label-data">Maximum Payout per Transaction</p>
              <input
                type="text"
                name="payoutMaxPerTxn"
                value={formData?.payoutMaxPerTxn}
                onChange={handleInputChange}
              />
            </>
          ) : null}

          {formData.type === "payin" || formData.type === "both" ? (
            <>
              <p className="label-data">Total Payin Limit</p>
              <input
                type="text"
                name="totalPayinLimit"
                value={formData?.totalPayinLimit}
                onChange={handleInputChange}
              />
            </>
          ) : null}

          {formData.type === "payout" || formData.type === "both" ? (
            <>
              <p className="label-data">Total Payout Limit</p>
              <input
                type="text"
                name="totalPayoutLimit"
                value={formData?.totalPayoutLimit}
                onChange={handleInputChange}
              />
            </>
          ) : null}
          {/* <p className="label-data">Running Wallet Amount</p>
          <input
            type="text"
            name="runningWalletAmount"
            value={formData?.runningWalletAmount}
            onChange={handleInputChange}
          />

          <p className="label-data">Daily Payin Amount</p>
          <input
            type="text"
            name="dailyPayinAmount"
            value={formData?.dailyPayinAmount}
            onChange={handleInputChange}
          /> */}
          <p className="label-data">Start Time</p>
          <input
            type="time"
            name="startTime"
            value={
              formData?.startTime
                ? new Date(formData.startTime).toLocaleTimeString("en-GB", {
                    timeZone: "Asia/Kolkata",
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                : ""
            }
            onChange={handleInputChange}
          />
          <p className="label-data">End Time</p>
          <input
            type="time"
            name="endTime"
            value={
              formData?.endTime
                ? new Date(formData.endTime).toLocaleTimeString("en-GB", {
                    timeZone: "Asia/Kolkata",
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                : ""
            }
            onChange={handleInputChange}
          />
          <p className="label-data">Valid Length</p>
          <div style={{ display: "flex", gap: "10px" }}>
            <input
              type="number"
              name="minLength"
              placeholder="Min"
              value={formData?.minLength ?? ""}
              onChange={handleInputChange}
              style={{ width: "80px" }}
            />

            <input
              type="number"
              name="maxLength"
              placeholder="Max"
              value={formData?.maxLength ?? ""}
              onChange={handleInputChange}
              style={{ width: "80px" }}
            />
          </div>

            <div>
              <p className="label-data">Fallback Provider Name</p>

              <Select
                placeholder="Select Fallback Provider"
                options={fallbackProviderOptions}
                value={fallbackProviderOptions.find(
                  (p) => p.value === formData.fallbackProviderId,
                )}
                onChange={(selected) =>
                  handleInputChange({
                    target: {
                      name: "fallbackProviderId",
                      value: selected?.value || "",
                    },
                  })
                }
                formatOptionLabel={(option) => (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <span
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor: option.isActive ? "green" : "red",
                      }}
                    />
                    <span>{`${option.orgName} - ${option.label}`}</span>
                  </div>
                )}
                styles={{
                  container: (base) => ({ ...base, width: "70%" }),
                }}
              />
            </div>

          <FormControl>
            <FormLabel className="label-data">Provider Active</FormLabel>
            <RadioGroup
              name="isActive"
              value={formData?.isActive}
              onChange={handleInputChange}
            >
              <FormControlLabel value={true} control={<Radio />} label="Yes" />
              <FormControlLabel value={false} control={<Radio />} label="No" />
            </RadioGroup>
          </FormControl>

          <div className="modal-buttons">
            <button type="submit">Update</button>
            <button type="button" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Modal;
